<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-06-20 10:46:07
-->
<template>
	<div>
		<el-drawer
			:title="`${isEdit ? '编辑' : '添加'}推广商品`"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="width"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="add-goods"
		>
			<Tip type="warning" :content="content" size="small" class="mb-16"></Tip>
			<Panel>
				<div class="flex-row-align-center flex-just-between">
					<goods-item :row="row" :platformId="platformId" />
					<div style="width: 100px" class="text-align-right">
						<el-button type="text" @click="replaceGoods" class="fz-12">更换商品</el-button>
					</div>
				</div>
			</Panel>
			<Panel>
				<!-- 弹窗内容部分 -->
				<el-form :model="form" ref="form" :rules="rules" :label-width="labelWidth">
					<el-form-item label="人工审核">
						<el-radio-group v-model="form.auditStatus">
							<el-radio label="1">是</el-radio>
							<el-radio label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="二级团服务费" prop="serviceFeeRate">
						<el-input
							placeholder="请输入"
							type="number"
							class="rate-input"
							style="width: 220px"
							@input="inputRule('serviceFeeRate')"
							v-model="form.serviceFeeRate"
						>
							<template slot="append">%</template>
						</el-input>
					</el-form-item>
					<el-form-item label="推广结束时间" class="mt-20">
						<el-date-picker v-model="promotionEndTime" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="团长保护期" class="mt-20" prop="authorityProtectionPeriod">
						<el-input placeholder="请输入" style="width: 220px" v-model="form.authorityProtectionPeriod">
							<template slot="append">个月</template>
						</el-input>
					</el-form-item>
					<el-form-item label="联系方式" class="mt-20">
						<div>
							<el-radio v-model="form.contactType" label="1">当前登录账号 ({{ mobile }})</el-radio>
						</div>
						<div class="flex-row-align-center other mt-8">
							<el-radio v-model="form.contactType" label="2">其他</el-radio>
							<el-input maxlength="11" v-if="form.contactType === '2'" placeholder="请输入" style="width: 182px" v-model="form.mobile"></el-input>
						</div>
					</el-form-item>
				</el-form>
			</Panel>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading" :disabled="!isDisable">确认</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { debounce } from 'lodash';
import goodsItem from './goodsItem.vue';
import { productCommonAdd, productCommonEdit, productCommonInfo } from '@/api/secondColonelManage';
import { mapState } from 'vuex';
import { checkPromotionProtect, checkServiceFeeRate, checkInputNumber } from '@/utils/validate';
import { endOfDay } from 'date-fns';
export default {
	components: {
		goodsItem,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false, // 弹窗显隐
			promotionEndTime: '',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			form: {
				serviceFeeRate: '',
				authorityProtectionPeriod: '0',
				mobile: '',
				auditStatus: '0',
				contactType: '1',
			}, // 表单数据
			rules: {
				authorityProtectionPeriod: [{ requied: false }, { validator: checkPromotionProtect, trigger: 'blur', msg: '请输入0-6的整数' }],
				serviceFeeRate: [{ requied: false }, { validator: checkServiceFeeRate, trigger: 'blur', msg: '请输入1-84.49的数字' }],
			},
			loading: false, // 按钮loading状态
			wrapperClosable: false,
			row: {},
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		...mapState(['vuex_userInfo']),
		mobile({ vuex_userInfo }) {
			return vuex_userInfo.mobile;
		},
		width() {
			return dataMap.DRAWER_SIZE_WIDTH[this.size];
		},
		isDisable({ form, promotionEndTime }) {
			let mobileCheck = form.contactType === '1' ? true : !!form.mobile;
			return form.serviceFeeRate && promotionEndTime && form.authorityProtectionPeriod && mobileCheck;
		},
		isEdit() {
			return this.row.isCommon;
		},
		content() {
			return this.isEdit
				? '设置公开推广后，商品将以您设置的机制展示给其他团长，其他团长同意后将自动报名并审核通过，有可能暴露您的商品机制'
				: '设置完成后商品机制将公开展示给团长，团长选中商品后将直接报名并通过团长的招商计划，如需停止与团长的合作，请在精选联盟后台或“活动”中停止该商品与团长的合作';
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(row) {
			this.row = row;
			if (row.isCommon) {
				this.editproduct();
			} else {
				this.promotionEndTime = new Date(row.promotionEndTime).getTime();
			}
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.form = {
				serviceFeeRate: '',
				authorityProtectionPeriod: '0',
				mobile: '',
				auditStatus: '0',
				contactType: '1',
			};
			this.promotionEndTime = '';
			// 关闭弹窗
			this.visible = false;
		},
		async editproduct() {
			const data = await productCommonInfo({ productId: this.row.productId });
			Object.keys(this.form).forEach(key => {
				this.form[key] = data[key];
			});
			this.promotionEndTime = +data.promotionEndTime;
		},
		replaceGoods() {
			this.form = {
				serviceFeeRate: '',
				authorityProtectionPeriod: '0',
				mobile: '',
				auditStatus: '0',
				contactType: '1',
			};
			this.promotionEndTime = '';
			this.$emit('replaceGoods', this.row);
		},
		inputRule(key) {
			this.form[key] = checkInputNumber(this.form[key], +this.platformId === +dataMap.PLATFORM_DY.value ? 2 : 1);
		},
		// 确认按钮点击事件
		confirm: debounce(async function () {
			// 按钮loading开启
			const { isEdit, platformId } = this;
			this.loading = true;
			try {
				if (this.form.contactType === '1') {
					this.form.mobile = this.mobile;
				}
				const api = {
					0: productCommonAdd,
					1: productCommonEdit,
				};
				const params = { ...this.form, productId: this.row.productId, promotionEndTime: endOfDay(this.promotionEndTime).getTime(), platformId };
				await (isEdit ? productCommonEdit(params) : productCommonAdd(params));
				this.$message.success('操作成功');
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 表单项标签宽度
			this.labelWidth = '100px';
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 抽屉尺寸，small:500px，default: 600px，normal:800px，large:1080px
			this.size = 'default';
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 20px;
	background-color: @color-gy2!important;
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-thumb {
		height: 26px;
		border-radius: 3px;
		background-color: @border-color-lighter;
	}
}
// 抽屉模版样式
.drawer-footer {
	position: absolute;
	width: 100%;
	left: 0;
	bottom: 0;
	padding: 10px;
	display: flex;
	justify-content: flex-end;
	border-top: 1px solid @color-gy3;
	background-color: @color-gy1;
}
.other {
	height: 40px;
	/deep/ .el-radio {
		margin-right: 8px;
	}
}
.rate-input {
	/deep/ .el-input__inner {
		border-right-color: transparent !important;
		border-color: @color-gy5;
	}
	/deep/ .el-input-group__append {
		color: @color-gy9;
	}
	/deep/ .el-input__inner::-webkit-inner-spin-button {
		-webkit-appearance: none;
		appearance: none;
	}
	/deep/ .el-input__inner[type='number'] {
		-moz-appearance: textfield;
	}
}
</style>